module.exports = __webpack_public_path__ + "static/media/go-cardless-logo.1831d25f.svg";